export class LoadInvitationByToken {
  static readonly type = '[Invitations] LoadInvitationByToken';
  constructor(public token: string) {}
}

export class AcceptInvitation {
  static readonly type = '[Invitations] AcceptInvitation';
  constructor(
    public token: string,
    public organizationIds: number[],
  ) {}
}

export class AcceptInvitationById {
  static readonly type = '[Invitations] AcceptInvitationById';
  constructor(
    public invitationId: number,
    public organizationIds: number[],
  ) {}
}

export class LoadInvitations {
  static readonly type = '[Invitations] Load';
}

export class RequestCollaborationCancellation {
  static readonly type = '[Invitations] RequestCollaborationCancellation';
  constructor(
    public relationshipId: number,
    public message?: string,
  ) {}
}

export class WithdrawCollaborationCancellation {
  static readonly type = '[Invitations] WithdrawCollaborationCancellation';
  constructor(public relationshipId: number) {}
}
